import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-gradient-to-b from-gray-900 to-motor-black py-20 px-4 sm:px-6 lg:px-8" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-8" data-id="element-70">
          <div className="flex justify-center" data-id="element-71">
            <motion.div whileHover={{
            scale: 1.1,
            rotate: 5
          }} className="w-32 h-32 bg-green-500/10 rounded-full flex items-center justify-center border-4 border-green-500 shadow-[0_0_30px_rgba(34,197,94,0.5)]" data-id="element-72">
              <Shield className="w-16 h-16 text-green-500" data-id="element-73" />
            </motion.div>
          </div>

          <div className="space-y-4" data-id="element-74">
            <h2 className="font-bebas text-4xl sm:text-5xl lg:text-6xl text-white uppercase" data-id="element-75">
              Garantía de 7 días
            </h2>

            <p className="text-2xl sm:text-3xl text-gray-300 font-montserrat font-semibold max-w-2xl mx-auto" data-id="element-76">
              Probalo 7 días. Si no te sirve, te devolvemos el dinero.
            </p>

            <p className="text-lg text-gray-400 font-montserrat max-w-xl mx-auto" data-id="element-77">
              Sin preguntas, sin vueltas. Tenés una semana completa para probar
              todo el contenido. Si no te convence, te devolvemos el 100% de tu
              dinero.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}